import { gql } from '@apollo/client';

export const GET_WORK_CATEGORIES_FOR_PROPCOMP = gql`
query {
  workCategories {
    id
    name
    text
    icon
    image
    parentId
    sortId
    level
    colour
    subComponent
    serviceCategoryId
  }
}
`;
